export const DATA_TEST_ID_HTML_ATTRIBUTE = 'data-testid';

export enum DataTestId {
  ANSWER_BUTTON = 'answer-button',
  ANSWER_BUTTON_DETAILED = 'answer-button-detailed',
  MULTIPLE_ANSWER_BUTTON = 'multiple-answer-button',
  NEXT_BUTTON = 'next-button',
  SUBMIT_BUTTON = 'submit-button',
  SKIP_BUTTON = 'skip-button',
  BACK_BUTTON = 'back-button',
  CANCEL_BUTTON = 'cancel-button',
  CONFIRM_BUTTON = 'confirm-button',
  CLEAR_BUTTON = 'clear-button',
  YES_BUTTON = 'yes-button',
  NO_BUTTON = 'no-button',
  TRY_AGAIN_BUTTON = 'try-again-button',
  MODAL = 'modal',
  MODAL_CLOSE_BUTTON = 'modal-close-button',
  QUESTION_MODAL = 'question-modal',
  QUESTION_MODAL_CLOSE_BUTTON = 'question-modal-close-button',
  ERROR_MESSAGE = 'error-message',
  DATE_PICKER_MODAL = 'date-picker-modal',
  DATE_PICKER_MODAL_CLOSE_BUTTON = 'date-picker-modal-close-button',
  TIME_PICKER_MODAL = 'time-picker-modal',
  TIME_PICKER_MODAL_CLOSE_BUTTON = 'time-picker-modal-close-button',

  POLICY_CHECKBOX = 'policy-checkbox',
  CONSENT_CHECKBOX = 'consent-checkbox',
  PLACE_INPUT = 'place-input',
  PLACE_LIST_ITEM = 'place-list-item',
  EMAIL_INPUT = 'email-input',
  EMAIL_LIST_ITEM = 'email-list-item',
  PASSWORD_INPUT = 'password-input',
  CONFIRM_PASSWORD_INPUT = 'confirm-password-input',
  NAME_INPUT = 'name-input',
  PHONE_NUMBER_INPUT = 'phone-number-input',
  DATE_INPUT = 'date-input',
  TIME_INPUT = 'time-input',
  PROGRESS_PERCENTAGE = 'progress-percentage',
  DETAILED_ANSWER_INPUT = 'detailed-answer-input',
  GENDER_SELECT = 'gender-select',
  PARTNER_GENDER_SELECT = 'partner-gender-select',
  PARTNER_IDEAL_AGE_SELECT = 'partner-ideal-age-select',
  ETHNIC_BACKGROUND_SELECT = 'ethnic-background-select',
  BIRTH_DAY_SELECT = 'birth-day-select',
  BIRTH_MONTH_SELECT = 'birth-month-select',
  BIRTH_YEAR_SELECT = 'birth-year-select',

  GOAL_TITLE = 'goal-title',
  GOAL_TEXT = 'goal-text',
  INFORMATIONAL_TITLE = 'informational-title',
  INFORMATIONAL_TEXT = 'informational-text',
  ONBOARDING_GOAL_TEXT = 'onboarding-goal-text',
  HELLO_TITLE = 'hello-moon-title',
  MOON_TITLE = 'moon-phase-title',
  MOON_TEXT = 'moon-phase-text',
  IMPORTANT_IMAGE = 'important-image',
  EMAIL_TITLE = 'email-title',

  // trial payment
  GET_REPORT_BUTTON = 'get-report-button', // the button opens the payment modal
  PAYMENT_ERROR_MODAL = 'payment-error-modal',
  PAYMENT_ERROR_BUTTON = 'payment-error-button',
  PAYMENT_MODAL_CLOSE_BUTTON = 'payment-modal-close-button',
  SPECIAL_OFFER_BLOCK = 'special-offer-block',
  PRICE_TITLE = 'price-title',
  OLD_PRICE_TEXT = 'old-price-text',
  PRICE_TEXT = 'price-text',
  SUBSCRIPTION_DESCRIPTION = 'subscription-description',
  SUBSCRIPTION_OLD_PRICE = 'subscription-old-price',
  SUBSCRIPTION_ACTUAL_PRICE = 'subscription-actual-price',
  PURCHASE_AGREEMENT = 'purchase-agreement',
  ZODIAC_TEXT = 'zodiac-text',
  GENDER_TEXT = 'gender-text',
  BIRTH_DATE_TEXT = 'birth-date-text',
  BIRTH_PLACE_TEXT = 'birth-place-text',
  GOAL_SECTION = 'goal-section',
  GOAL_SECTION_TEXT = 'goal-section-text',
  GUIDE_LIST_ITEM = 'guide-list-item',
  // palmistry
  TAKE_PHOTO_BUTTON = 'take-photo-button',
  SKIP_UPLOAD_BUTTON = 'skip-upload-button',
  OPEN_SCAN_BUTTON = 'open-scan-button',
  SKIP_TAKE_PHOTO_BUTTON = 'skip-take-photo-button',
  SCAN_DISCLAIMER = 'scan-disclaimer',
  // upsells
  GET_UPSELL_BUTTON = 'get-upsell-button',
  GET_CREDITS_UPSELL_BUTTON = 'get-credits-button',
  UPSELL_RADIO_BUTTON = 'upsell-radio-button',
  UPSELL_RADIO_BUTTON_LABEL = 'upsell-radio-button-label',
  UPSELL_DISCOUNT_MODAL_CLOSE_BUTTON = 'upsell-discount-modal-close-button',
  // trial choice templates
  TRIAL_CHOICE_RADIO_BUTTON_LABEL = 'trial-choice-radio-button-label',
  TRIAL_CHOICE_GOAL_TEXT = 'trial-choice-goal-text',
  // zodiac
  ZODIAC_ITEM_LIST = 'zodiac-item-list',

  PAYPAL_TAB = 'paypal-tab',
  APPLE_PAY_TAB = 'apple-pay-tab',
  GOOGLE_PAY_TAB = 'google-pay-tab',
  PIX_TAB = 'pix-tab',
  CARD_TAB = 'card-tab',
  CHARGE_DISCLAIMER = 'charge-disclaimer',
  PAYPAL_PANEL = 'paypal-panel',
  APPLE_PAY_PANEL = 'apple-pay-panel',
  GOOGLE_PAY_PANEL = 'google-pay-panel',
  APPLE_PAY_BUTTON = 'apple-pay-button',
  GOOGLE_PAY_BUTTON = 'google-pay-button',
  PIX_PANEL = 'pix-panel',
  CARD_PANEL = 'card-panel',
  ADD_TO_CART_BUTTON = 'add-to-cart-button',

  QR_CODE_CANVAS = 'qr-code-canvas',

  UPSSELL_DISCOUNT_MODAL_SKIP_BUTTON = 'upsell-discount-modal-skip-button',
  UPSSELL_DISCOUNT_MODAL_GET_BUTTON = 'upsell-discount-modal-get-button',
  UPSSELL_DISCOUNT_MODAL = 'upsell-discount-modal',
}
